import { apiClient } from './apiClient';
import { ApiResponse } from '../../types/route.types';

export interface RoutesApiParams {
  activities?: string;
  limit?: number;
  page?: number;
}

/**
 * API pour les routes
 */
export const routesApi = {
  /**
   * Récupère les routes depuis l'API
   */
  async getRoutes(params?: RoutesApiParams): Promise<ApiResponse> {
    const queryParams: Record<string, string> = {};

    if (params?.limit) {
      queryParams.limit = params.limit.toString();
    }

    if (params?.page) {
      queryParams.page = params.page.toString();
    }

    if (params?.activities) {
      queryParams.activities = params.activities;
    }

    return apiClient.get<ApiResponse>('/routes', queryParams);
  },

  /**
   * Récupère les routes depuis les fichiers statiques (fallback)
   */
  async getRoutesFromStatic(activity?: string): Promise<ApiResponse> {
    const fileName = activity ? `${activity}.json` : 'all.json';
    const response = await fetch(`/data/${fileName}`);

    if (!response.ok) {
      throw new Error(`Failed to load static data: ${response.status}`);
    }

    return response.json();
  },
};
